import React from 'react'
import { View } from 'react-native'

import { router } from 'expo-router'

import { DS } from '@/design-system'

import { AvatarBuilder } from '@/screens/profile-screen/edit/AvatarBuilder'
import { useHandleSave, useHandleCancel, useAvatarStore } from '@/screens/profile-screen/edit/AvatarModule'

function AvatarCreator(){
  return (
    <View style={{flex: 1, gap: 24}}>
      <AvatarBuilder />
      <AvatarBtns />
    </View>
  )
}

function AvatarBtns(){

  const handleCancel = useHandleCancel()
  const handleSave = useHandleSave()
  const error = useAvatarStore(s => s.error)

  const onPressSave = async () => {
    const success = await handleSave()
    if (success) router.navigate('/onboarding/skill-level')
  }

  const onPressSkip = () => {
    handleCancel()
    router.navigate('/onboarding/skill-level')
  }

  return (
    <View style={{gap:8}}>

      <View style={{flexDirection: "row", gap: 8}}>
        <DS.Button style={{flex: 1}} variant="Medium/Secondary" type="On Dark" onPress={onPressSkip}>
          Skip
        </DS.Button> 
        <DS.Button style={{flex: 1}} variant="Medium/Primary" type="On Light" onPress={onPressSave}>
          Save
        </DS.Button>
      </View>

      {error &&
      <DS.Text variant="Body Small/Regular" style={{ color: DS.palette['Utility/Error'] }}>
        Could not save.  Please try again.
      </DS.Text>
      }

    </View>
  )
}

export { AvatarCreator }
